<forge-card class="bond-card">
  <forge-expansion-panel>
    <div slot="header" role="button" tabindex="0">
      <forge-label-value>
        <label for="span-amount" slot="label">{{bond.type | na}}</label>
        <span id="span-amount" slot="value">{{bond.amount | currency}}</span>
      </forge-label-value>
      <forge-badge theme="info-secondary">{{bond.charges?.length ?? 0}}</forge-badge>
      <forge-open-icon></forge-open-icon>
    </div>
    <forge-divider></forge-divider>
    <forge-card class="bond-details">
      <forge-label-value>
        <span slot="label">Associated charges</span>
      </forge-label-value>
      <div class="charge-details">
        @for (charge of bond.charges; track charge) {
        <forge-card class="charge-description">
          <span class="charge-description-item">{{charge.statute?.description | na}}</span>
        </forge-card>
        }
      </div>
      @if (displayBondFees && shouldShowFeesOnBond && bondFees && bondFees.length > 0) {
      <forge-divider></forge-divider>
      <forge-label-value>
        <span slot="label">Bond fees</span>
      </forge-label-value>
      <div class="fee-details">
        @for (fee of bondFees; track fee; let i = $index) {
        <forge-card class="fee-item">
          <forge-label-value>
            <label slot="label">{{fee.description | na}}</label>
            <span slot="value">{{fee.amount | currency}}</span>
          </forge-label-value>
        </forge-card>
        }
      </div>
      }
      @if (displayBondFees && shouldShowContactFacility) {
      <forge-divider></forge-divider>
      <forge-label-value>
        <span slot="label">Bond fees</span>
      </forge-label-value>
      <p class="contact-facility-message">Contact facility for bond fee information</p>
      }
    </forge-card>
  </forge-expansion-panel>
</forge-card>